import React from 'react';
import styles from './About.module.scss';
import geek from 'assets/geek.png';
import notebook from 'assets/computer.png';
import map from 'assets/map.png';

const About = () => {
    return (
        <section id="about" className={styles.about}>
            <div className={styles.container}>
                <div className={styles['image-container']}>
                    <img className={styles.geek} src={geek} alt=""/>
                    <img className={styles.notebook} src={notebook} alt=""/>
                </div>
                <div className={styles['text-container']}>
                    <h3>About me</h3>
                    <h2>A dedicated Front-end Developer based in Dublin, Ireland <img src={map} alt="icon" /></h2>
                    <p>As a <span className={styles['blue']}>Junior Front-End Developer with a Bachelor's degree in Information Systems</span>, I possess an impressive arsenal of skills in HTML, CSS, JavaScript, React, Tailwind, and SCSS. I excel in designing and maintaining responsive websites that offer a smooth user experience. My expertise lies in crafting dynamic, engaging interfaces through writing clean and optimised code and utilising cutting-edge development tools and techniques. I am also a team player who thrives in collaborating with cross-functional teams to produce outstanding web applications.</p>
                    <p>
                    As I embark on my journey as a Front-End Developer, my dedication and enthusiasm drive me to explore new concepts, learn new technologies, and refine my craft. I am excited about the endless possibilities that lie ahead in the ever-evolving world of web development, and I am committed to making a meaningful impact through my work.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default About;
